// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ejWiDf1TW6AUjNLAmq3OQ"};